import type { LucideIcon } from 'lucide-react';
import { BookOpen } from 'lucide-react';

/**
 * Пункты бокового меню, которые ведут ВОН из SPA (новая вкладка). Не модули:
 * у них нет маршрутов в панели и нет пространства, поэтому они стоят под
 * списком разделов в любом пространстве — у маркетолога с его урезанной
 * «Рекламой» тоже.
 */
export interface ExternalNavLink {
  key: string;
  label: string;
  icon: LucideIcon;
  href: string;
}

/** Политика `packages/rbac`: owner / supervisor / marketing, не отключён. */
export const MCP_DOCS_PERMISSION = 'mcp_docs.read';

/** Часть `/api/me`, по которой решаются внешние ссылки. */
export interface ExternalLinksMe {
  permissions: readonly string[];
  /**
   * Признаки сервера. Старый admin-api (до выката) поля не шлёт, а `/api/me`
   * в панели не парсится схемой — поэтому всё, что не строго `true`, = «выкл».
   */
  features?: { mcpDocs?: boolean } | null | undefined;
}

/**
 * Внешние ссылки, доступные оператору.
 *
 * «Документация MCP» — только при ДВУХ условиях из `/api/me`: право
 * `mcp_docs.read` (тот же ключ, которым admin-api закрывает саму страницу) И
 * `features.mcpDocs === true` (страница на этом admin-api смонтирована: без
 * `MCP_DOCS_TOKEN` или без собранного Scalar её нет, ссылка вела бы на 404).
 *
 * `apiOrigin` — origin admin-api: документация отдаётся им (`/docs/mcp`), там
 * же живёт cookie сессии.
 */
export function externalNavLinksFor(me: ExternalLinksMe, apiOrigin: string): ExternalNavLink[] {
  const links: ExternalNavLink[] = [];
  if (me.permissions.includes(MCP_DOCS_PERMISSION) && me.features?.mcpDocs === true) {
    links.push({
      key: 'mcp-docs',
      label: 'Документация MCP',
      icon: BookOpen,
      href: `${apiOrigin}/docs/mcp`,
    });
  }
  return links;
}
